/* import {  } from '@/scripts/constants/test'; */
// import store from '@/scripts/store';
import { daysSet, monthsSet, yearsSet } from '@/scripts/constants/map';
import { setLeadingNumbers } from '@/scripts/utils/number';

const createDate = (date, params = {}) => {
  const { days, months, years } = date;
  const d = parseInt(days);
  const m = parseInt(months);
  const y = parseInt(years);
  const { format = 'iso' } = params;

  const utc = Date.UTC(y, m, d);

  if (!utc) return;

  const dateObj = new Date(utc);
  const isoString = dateObj.toISOString();

  let result = dateObj;

  switch (format) {
    case 'iso':
      result = isoString;
      break;
  }

  return result;
};

const getDateFromUser = (user = {}) => {
  const { dateOfBirth } = user;
  const [y, m, d] = dateOfBirth.split('-');
  const correctedMonth = parseInt(m) - 1;
  const dateObjectUtc = new Date(Date.UTC(y, correctedMonth, d));

  const days = dateObjectUtc.getUTCDate();
  const months = dateObjectUtc.getUTCMonth();
  const years = dateObjectUtc.getUTCFullYear();

  const result = {
    years,
    months,
    days,
  };

  return result;
};

const getDropdownDate = values => {
  const days = daysSet.find(
    ({ value }) => `${values.days}` === `${parseInt(value)}`
  );
  const months = monthsSet.find(
    ({ value }) => `${values.months}` === `${parseInt(value)}`
  );
  const years = yearsSet.find(({ value }) => `${values.years}` === `${value}`);

  const result = {
    days,
    months,
    years,
  };

  return result;
};

const humanizeDate = date => {
  const dateObject = new Date(date);
  if (Number.isNaN(dateObject)) {
    return '';
  }

  const year = dateObject.getFullYear();
  const yearLastNumber = year.toString().slice(2);

  const monthArray = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
  ];
  const month = (1 + dateObject.getMonth()).toString();

  let day = dateObject.getDate().toString();
  day = day.length > 1 ? day : `0${day}`;

  return `${day} ${monthArray[month - 1]} ${yearLastNumber}`;
};

const timeFormatEnUs = date => {
  const dateObject = new Date(date);
  if (Number.isNaN(dateObject)) {
    return '';
  }

  let hh = dateObject.getHours();
  let mm = dateObject.getMinutes();
  const ampm = hh >= 12 ? 'PM' : 'AM';

  hh %= 12;
  hh = hh || 12;

  mm = mm < 10 ? `0${mm}` : mm;

  return `${hh}:${mm} ${ampm}`;
};

const countablePostfix = input => {
  if (!input) return '';

  const d = parseInt(input, 10);

  if (!d) return '';

  if (d > 3 && d < 21) return 'th';

  switch (d % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

const secondsToTime = s => {
  const date = new Date(null);

  date.setSeconds(s);

  var hh = date.getUTCHours();
  var mm = date.getUTCMinutes();
  var ss = date.getSeconds();
  const result = `${hh ? `${setLeadingNumbers(hh)}:` : ''}${setLeadingNumbers(
    mm
  )}:${setLeadingNumbers(ss)}`;

  return result;
};

/*  */
export {
  createDate,
  getDateFromUser,
  getDropdownDate,
  humanizeDate,
  timeFormatEnUs,
  countablePostfix,
  secondsToTime,
};
